"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.sanitizeInputProps = exports.parseDate = exports.formatDate = exports.isValidStringDate = exports.isEmpty = exports.noop = void 0;

var _moment = _interopRequireDefault(require("moment"));

var noop = function noop() {};

exports.noop = noop;

var isEmpty = function isEmpty(value) {
  if (typeof value === 'boolean') {
    return value === false;
  } else if (typeof value === 'string') {
    return value.trim().length === 0;
  } else if (typeof value === 'number') {
    return isNaN(value);
  } else if (value instanceof Date) {
    return isNaN(value);
  } else if (value instanceof Array) {
    return value.length === 0;
  } else if (value instanceof Object) {
    return Object.keys(value).length === 0;
  } else {
    return value === undefined || value === null;
  }
};

exports.isEmpty = isEmpty;

var isValidStringDate = function isValidStringDate(stringDate, format) {
  if (format === void 0) {
    format = 'L';
  }

  return (0, _moment.default)(stringDate, format, true).isValid();
};

exports.isValidStringDate = isValidStringDate;

var formatDate = function formatDate(date, format) {
  if (format === void 0) {
    format = 'L';
  }

  if (date && isValidStringDate(date, format)) {
    return (0, _moment.default)(date).format(format);
  }
};

exports.formatDate = formatDate;

var parseDate = function parseDate(date, format) {
  if (format === void 0) {
    format = 'L';
  }

  return (0, _moment.default)(date, format, true).toDate();
};

exports.parseDate = parseDate;

var sanitizeInputProps = function sanitizeInputProps(_ref) {
  var id = _ref.id,
      name = _ref.name,
      type = _ref.type,
      htmlFor = _ref.htmlFor,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      checked = _ref.checked,
      className = _ref.className,
      required = _ref.required,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      onKeyPress = _ref.onKeyPress,
      onKeyUp = _ref.onKeyUp,
      pattern = _ref.pattern,
      size = _ref.size,
      maxLength = _ref.maxLength,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      multiple = _ref.multiple,
      height = _ref.height,
      width = _ref.width;
  return {
    id: id,
    name: name,
    type: type,
    htmlFor: htmlFor,
    readOnly: readOnly,
    disabled: disabled,
    placeholder: placeholder,
    defaultValue: defaultValue,
    value: value,
    checked: checked,
    className: className,
    required: required,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    // callbacks
    onChange: onChange,
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress,
    onKeyUp: onKeyUp,
    // validation props
    pattern: pattern,
    size: size,
    maxLength: maxLength,
    min: min,
    max: max,
    step: step,
    multiple: multiple,
    height: height,
    width: width
  };
};

exports.sanitizeInputProps = sanitizeInputProps;